/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientResource
 */
export interface ClientResource {
    /**
     * 
     * @type {string}
     * @memberof ClientResource
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof ClientResource
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof ClientResource
     */
    fullName: string;
}

/**
 * Check if a given object implements the ClientResource interface.
 */
export function instanceOfClientResource(value: object): value is ClientResource {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    return true;
}

export function ClientResourceFromJSON(json: any): ClientResource {
    return ClientResourceFromJSONTyped(json, false);
}

export function ClientResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientResource {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'],
        'identityId': json['identityId'],
        'fullName': json['fullName'],
    };
}

export function ClientResourceToJSON(value?: ClientResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'identityId': value['identityId'],
        'fullName': value['fullName'],
    };
}

